// Varukorgstips: "Lägg till"-knappar + tips i varukorgslådan (Impulse)
(function () {
  if (window.__cartTipsInit) return;
  window.__cartTipsInit = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // Lägg i varukorgen via AJAX och uppdatera korgen
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-tip-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw r; })
      .then(function () {
        if (btn.closest('#CartDrawer')) {
          // Impulse bygger om lådan på cart:build
          document.dispatchEvent(new CustomEvent('cart:build'));
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Kunde inte läggas till';
      });
  });

  // Hämta tips till varukorgslådan när dess innehåll ändras
  var timer;
  function refreshDrawer() {
    var slot = document.querySelector('#CartDrawer [data-cart-tips-drawer]');
    if (!slot) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      // Hela varukorgssidan: sektionens ID i mallen är dynamiskt och
      // section_id=cart-tips skulle rendera utan mallens inställningar
      fetch(root + 'cart')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var tips = doc.querySelector('[data-cart-tips]');
          slot.innerHTML = tips ? tips.innerHTML : '';
        });
    }, 300);
  }

  function init() {
    var list = document.querySelector('#CartDrawer [data-products]');
    if (list) new MutationObserver(refreshDrawer).observe(list, { childList: true });
    ['cart:updated', 'ajaxProduct:added', 'cartdrawer:opened'].forEach(function (ev) {
      document.addEventListener(ev, refreshDrawer);
    });
    refreshDrawer();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
